export { PDFPage, type PDFPageProps } from './PDFPage';
export { CanvasLayer, type CanvasLayerProps } from './CanvasLayer';
export { TextLayer, type TextLayerProps } from './TextLayer';
export { HighlightLayer, type HighlightLayerProps } from './HighlightLayer';
export { AnnotationLayer, type AnnotationLayerProps } from './AnnotationLayer';
export { FocusRegionLayer, type FocusRegionLayerProps } from './FocusRegionLayer';
